export default __webpack_public_path__ + "static/media/qrisLogo.efa4f2f8.svg";